import React, { useState, useEffect, useCallback } from "react";
import { Button, Container } from "react-bootstrap";
import { useWallet } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import gulp from "../../Assets/Gulprageolutta_optimized.gif";
import { WalletModalButton, useWalletModal } from "@solana/wallet-adapter-react-ui";
import { useNavigate } from "react-router-dom";
import './../../style.css';

const NFT_MINT_ADDRESS = new PublicKey("EQ2zqNT56HyibwKSFhwP9wRhzHyZLwpgiuRUAiq3ovt7");

function Collectors() {
  const navigate = useNavigate();
  const wallet = useWallet();
  const { setVisible } = useWalletModal();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [ownershipVerified, setOwnershipVerified] = useState(false);
  const [triggerVerification, setTriggerVerification] = useState(false);

  // Auto-verify when wallet connects and trigger is true
  useEffect(() => {
    if (wallet.connected && triggerVerification) {
      handleVerifyOwnership();
    }
  }, [wallet.connected, triggerVerification]);


  useEffect(() => {
    if (!wallet.connected || !wallet.publicKey) {
      localStorage.clear();
    }
  }, [wallet.connected, wallet.publicKey]);

  const handleConnectAndVerify = () => {
    setTriggerVerification(true);
    setVisible(true); // opens wallet modal
  };

  const handleVerifyOwnership = useCallback(async () => {
    if (!wallet.publicKey || !wallet.signMessage) {
      setError("Wallet is not properly configured!");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const message = new TextEncoder().encode("Please verify my wallet ownership.");
      const signature = await wallet.signMessage(message);
      const response = await fetch("https://api.pall-o.com/verify", {
        method: "POST", // Make sure it's POST
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          publicKey: wallet.publicKey.toString(),
          signature: Array.from(signature),
          message: Array.from(message),
        }),
      });

      const data = await response.json();

      if (data.success) {
        setOwnershipVerified(true);
        navigate("/verify", { replace: true });
      } else {
        setError(data.error || "Access denied. You don't hold the NFT.");
      }
    } catch (err) {
      console.error("Verification error:", err);
      setError("Something went wrong verifying ownership.");
    }

    setLoading(false);
  }, [wallet, navigate]);

  return (
    <Container>
      <Container className="collectors">
        <p style={{ fontSize: "40px", fontWeight: "bold" }}>Digital collectibles</p>
        <img src={gulp} className="feature-image" alt="gulp" />
        <br/>
        <p>
          Are you a part of Pall-O network? <br />
          Connect your wallet to verify ownership to read the comics.
        </p>
        <br/>
        <p>
        Might want to use desktop for best performance.
        <br />
        Use wallet browser or regular on mobile if you're brave enough.
        </p>
        <p>
        Good art might take some extra seconds to load.
        <br />
        (Consider dopamine detox if you feel impatient.)
        </p>
        <Button
          className="buttonBig"
          variant="primary"
          onClick={handleConnectAndVerify}
          disabled={loading}
        >
          {loading ? "Verifying..." : "Connect & Verify"}
        </Button>

        {ownershipVerified && (
          <p style={{ color: "green", marginTop: "10px" }}>🎉 Ownership Verified!</p>
        )}
        {error && (
          <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
        )}
      </Container>
    </Container>
  );
}

export default Collectors;